module.exports = __webpack_public_path__ + "static/media/spis_tresci_matlandia_junior.f10f01f7.pdf";